import clientDeepLinks from "./clientDeepLinks";
import handleDeepLink from "./handleDeepLink";
import rfStore from "./rfStore";

export default function directToClientLogin() {
  const rfStoreState = rfStore.getRFState();
  // out_client
  if (!rfStoreState || !rfStoreState.model) {
    return;
  }

  handleDeepLink(clientDeepLinks.loginPage(""));
  rfStore.setRFState({
    ...rfStoreState,
    token: "",
  });
}
